<template>
  <v-app id="app" :light="!darkMode" :dark="darkMode">
    <div v-if="anyLoading" class="loading">
      <v-progress-linear :indeterminate="true" :color="progressColor" height="2" class="ma-0" />
    </div>

    <router-view name="navbar" />

    <transition name="reg-slide-fade" mode="out-in">
      <router-view />
    </transition>
    <global-upload-status />
    <onboarding-widget v-if="$loggedUser?.id && $roleAdminAndUp" />
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import GlobalUploadStatus from '~sendData/dropZone/GlobalUploadStatus.vue'
import OnboardingWidget from '@/components/onboarding/OnboardingWidget.vue'
export default {
  name: 'App',
  components: {
    GlobalUploadStatus,
    OnboardingWidget
  },
  data() {
    return {
      progressColor: 'primary'
    }
  },
  computed: {
    ...mapGetters(['anyLoading']),
    ...mapState({
      currentRoute: state => state.currentRoute,
      darkMode: state => state.darkMode
    })
  },
  watch: {
    currentRoute() {
      this.$nextTick(() => {
        this.$el.scrollTop = 0
      })
    },
    anyLoading() {
      if (this.anyLoading) {
        this.progressColor = 'primary'
        setTimeout(() => {
          this.progressColor = 'warning'
          setTimeout(() => {
            this.progressColor = 'error'
          }, 1000 * 10)
        }, 1000 * 5)
      }
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Lato');
#app,
body,
html {
  overflow: hidden !important;
  font-family: 'Lato', sans-serif;
  overscroll-behavior-x: none; /* Prevent back/forward swipe gestures */
}

// Fixture for Autodesk Viewer

th {
    border: none !important;
}

.application--wrap {
  overflow: hidden;
}

.v-content__wrap {
  overflow: hidden;
  z-index: 1;
}

.flex-container {
  display: flex !important;
  flex-direction: column !important;
  flex-grow: 1 !important;
}

.flex-toolbar {
  display: flex !important;
  flex-direction: column !important;
  flex-shrink: 1 !important;
}

.maxWidth {
  max-width: 1440px !important;
}

.reg-left-nav {
  width: auto;
  z-index: 1;
  overflow: hidden;
  @media screen and (max-width: 600px) {
    min-width: 100vw !important;
  }
}

.v-navigation-drawer__border {
  display: none;
}

.loading {
  width: 100%;
  height: 3px;
  position: absolute;
  background: rgba(145, 145, 145, 0.5);
  z-index: 20;
}

.loading > .v-progress-linear {
  margin: 0;
}

.fa,
.icon,
.icon.fa {
  font-size: 22px;
}

.reg-card-default {
  min-height: 30vh;
}
.fs-10 {
  font-size: 10px;
}

.loading-dots:after {
  content: ' .';
  animation: dots 1s steps(5, end) infinite;
}
@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: black;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  100%,
  80% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 black;
  }
}

.reg-fade-enter-active {
  transition: all 0.3s ease;
}
.reg-fade-leave-active {
  transition: all 0.3s ease;
}
.reg-fade-enter {
  opacity: 0;
}
.reg-fade-leave-to {
  opacity: 0;
}

.reg-slide-fade-enter-active {
  transition: all 0.3s ease;
}
.reg-slide-fade-leave-active {
  transition: all 0.3s ease;
}
.reg-slide-fade-enter {
  transform: translateX(-50px);
  opacity: 0;
}
.reg-slide-fade-leave-to {
  transform: translateX(50px);
  opacity: 0;
}

.reg-slide-down-enter-active {
  transition: all 0.3s ease;
}
.reg-slide-down-leave-active {
  transition: all 0.3s ease;
}
.reg-slide-down-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.reg-slide-down-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}

.reg-slide-nav-enter-active {
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.reg-slide-nav-leave-active {
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.reg-slide-nav-enter {
  transform: translateX(-300px);
  opacity: 0;
}
.reg-slide-nav-leave-to {
  transform: translateX(-300px);
  opacity: 0;
}

.reg-shake-badge .v-badge__badge {
  animation: shake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  animation-iteration-count: infinite;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  left: 15px;
}

.badge--small .v-badge__badge {
  height: 18px !important;
  width: 18px !important;
  font-size: 11px !important;
  font-weight: bold;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.v-tabs__content {
  transition: none;
}

.reg-editable-side-item {
  cursor: pointer;
}

.v-menu__content {
  @media screen and (max-width: 600px) {
    max-width: 92%;
  }
}

.reg-information {
  page-break-inside: avoid;
  margin: 5px auto;
  label {
    font-size: 1.1em;
    > button {
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
      margin: 0 6px;
      padding: 2px;
      border-radius: 50%;
      line-height: 14px;
      > i {
        font-size: 14px;
        color: #1b75bc;
        width: 14px;
        min-width: 14px;
        height: 14px;
        min-height: 14px;
        line-height: 14px;
      }
    }
  }
  p {
    font-size: 1.3em;
    color: #1b75bc;
    margin: 2px;
  }
}

.reg-information-small {
  page-break-inside: avoid;
  margin: 0px auto;
  label {
    font-size: 0.9em;
    > button {
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
      margin: 0 6px;
      padding: 2px;
      border-radius: 50%;
      line-height: 14px;
      > i {
        font-size: 14px;
        color: #1b75bc;
        width: 14px;
        min-width: 14px;
        height: 14px;
        min-height: 14px;
        line-height: 14px;
      }
    }
  }
  p {
    font-size: 1em;
    color: #1b75bc;
    margin: 0px;
  }
}

.text-strong {
  font-weight: bold;
}

.clickable {
  cursor: pointer;
}

.loading-text:after {
  display: inline-block;
  animation: dotty steps(1, end) 1s infinite;
  content: '';
  width: 15px;
  text-align: left;
  margin-left: 2px;
}

@keyframes dotty {
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
  100% {
    content: '';
  }
}
.v-btn--nano {
  font-size: 10px;
  height: 24px !important;
  width: 24px !important;
}

.v-btn--small--square {
  height: 28px !important;
  width: 28px !important;
  padding: 0 !important;
  min-width: 34px !important;
}

.v-btn--square {
  height: 36px !important;
  width: 36px !important;
  padding: 0 !important;
  min-width: 36px !important;
}

.fa {
  font-size: 18px;
}

.subtitle {
  font-size: 18px !important;
}

@media not print {
  .print-only {
    display: none !important;
  }
}

@media print {
  .screen-only {
    display: none !important;
  }
}

.table.v-table thead th {
  font-size: 14px;
}

.reg-center-checkbox {
  .v-input--selection-controls__input {
    margin: auto;
  }
}

.reg-link-button {
  text-decoration: none;
  .v-icon {
    font-size: 12px;
  }

  :hover {
    font-weight: 400;
  }
}
.reg-link-button:hover {
  font-weight: 600;
}

.v-text-field,
.reg-hide-line > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

// Path vuetify
.v-text-field--full-width.v-text-field--single-line.v-text-field--solo input {
    margin-top: 0px !important;
}

.v-text-field.v-text-field--full-width .v-input__prepend-outer,
.v-text-field.v-text-field--full-width .v-input__append-outer {
  margin-top: 16px !important;
}

.text-prefer-wrap {
    white-space: pre-wrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 1.1 !important;
}

.rotate-image-00 {
    transform: rotate(0deg);
}

.rotate-image-90 {
  .v-image {
    transform: rotate(90deg) !important;
  }
}

.rotate-image-180 {
  .v-image {
    transform: rotate(180deg) !important;
  }
}

.rotate-image-270 {
  .v-image {
    transform: rotate(270deg) !important;
  }
}

.theme--light.v-text-field--box > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.03) !important;
  transition: background 0.5s ease;
}

.theme--light.v-text-field--box:hover > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.08) !important;
}

.theme--light.v-text-field--box:focus-within > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.08) !important;
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-bottom: none;
}

.file-card {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background: rgba(0, 0, 0, 0.03) !important;
  transition: background 0.5s ease;
  .v-card__text {
    border-bottom: 1px solid #343434 !important;
  }
}

.file-card:hover, .file-card:focus-within {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background: rgba(0, 0, 0, 0.08) !important;
}

.v-input {
  .v-text-field__details {
    opacity: 0;
    transition: opacity 0.5s ease;
  }
}

.v-input:not(.error--text):hover,
.v-input:not(.error--text):focus-within {
  .v-text-field__details {
    opacity: 1;
  }
}

.v-input.error--text {
  .v-text-field__details {
    opacity: 1;
  }
}

.rounded-card {
  border-radius: 15px !important;
}

.theme--light.v-text-field.no-border > .v-input__control > .v-input__slot::before{
  border-width: 0 !important;
}

.theme--light.v-text-field.no-border > .v-input__control > .v-input__slot::after{
  border-width: 0 !important;
}

.theme--light.v-autocomplete.no-border > .v-input__control > .v-input__slot::after{
  border-width: 0 !important;
}

.mb-10 {
  margin-bottom: 100px !important;
}

.mb-20 {
  margin-bottom: 200px !important;
}
</style>
